<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="mdi-post">
        Add Postcode

        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12">
      <AddPostcode />
    </v-col>
  </v-row>
</template> 

<script>
import AddPostcode from "@/components/deliveryPostcodes/Add.vue";

export default {
  name: "OrderDiscountsAdd",

  components: {
    AddPostcode,
  },
};
</script>

<style lang="sass" scoped>
</style>

